import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { isEqual } from 'lodash';
import { getComputedCSSVariable } from '../../../utils/cssVariableHelpers';
import IndexLength from '../widgets/IndexLength';
import useResize from '../../../utils/hooks/useResize';
import { AdminDashboardTab } from './interfaces';

interface Props {
  tabs: Array<AdminDashboardTab>,
  currentTab: string,
  searchClient: any,
}

const AdminDashboardTableTabs: React.FC<Props> = ({
  tabs,
  currentTab,
  searchClient,
}) => {
  const [selectedTab, setSelectedTab] = useState<AdminDashboardTab>();
  const dimensions = useResize();

  useEffect(() => {
    const newSelected = tabs.find((tab) => currentTab === tab.key);
    if (!isEqual(newSelected, selectedTab)) {
      setSelectedTab(newSelected);
    }
  }, [currentTab, selectedTab]);

  if (!selectedTab) {
    return (
      <Spinner animation="grow" variant="primary" />
    );
  }

  if (dimensions?.width && dimensions?.width < 768) {
    return (
      <div className="dropdown">
        <a
          className="nav-link dropdown-toggle"
          data-toggle="dropdown"
          href="#"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <div
            className="dropdown-item d-flex align-items-center pl-1 pr-3 py-2 admin-dashboard-tab-wrapper active"
          >
            <p className="action-font text-uppercase text-dark-btn-txt m-0">
              <span className="icon mr-3">
                <FontAwesomeIcon icon={faChevronDown} color={getComputedCSSVariable('dark-btn-txt')} />
              </span>
              {selectedTab.title}
            </p>
            {selectedTab.showCountInTab && (
              <div className="h-100 ml-2 p-1 text-blue-400 action-font bg-admin-gray count-container">
                <IndexLength
                  searchClient={searchClient}
                  indexName={selectedTab.indexName ? selectedTab.indexName : ''}
                  facetFilters={selectedTab.facetFilters ? selectedTab.facetFilters : []}
                  numericFilters={selectedTab.numericFilters ? selectedTab.numericFilters : []}
                />
              </div>
            )}
          </div>
        </a>
        <div className="dropdown-menu w-100 px-3">
          {
            tabs.map((tab: AdminDashboardTab) => {
              if (tab.key === currentTab) {
                return null;
              }
              return (
                <div
                  key={tab.route}
                  className={`dropdown-item d-flex align-items-center px-3 py-2 admin-dashboard-tab-wrapper${currentTab === tab.key ? ' active' : ''}`}
                >
                  <a
                    className="action-font text-uppercase text-dark-btn-txt"
                    href={tab.route}
                  >
                    {tab.title}
                  </a>
                  {tab.showCountInTab && (
                    <div className="h-100 ml-2 p-1 text-blue-400 action-font bg-admin-gray count-container">
                      <IndexLength
                        searchClient={searchClient}
                        indexName={tab.indexName ? tab.indexName : ''}
                        facetFilters={tab.facetFilters ? tab.facetFilters : []}
                        numericFilters={tab.numericFilters ? tab.numericFilters : []}
                      />
                    </div>
                  )}
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-wrap">
      {
        tabs.map((tab: AdminDashboardTab) => {
          return (
            <div
              key={tab.route}
              className={`d-flex align-items-center px-3 py-2 admin-dashboard-tab-wrapper${currentTab === tab.key ? ' active' : ''}`}
            >
              <a
                className="action-font text-uppercase text-dark-btn-txt"
                href={tab.route}
              >
                {tab.title}
              </a>
              {tab.showCountInTab && (
                <div className="h-100 ml-2 p-1 text-blue-400 action-font bg-admin-gray count-container">
                  <IndexLength
                    searchClient={searchClient}
                    indexName={tab.indexName ? tab.indexName : ''}
                    facetFilters={tab.facetFilters ? tab.facetFilters : []}
                    numericFilters={tab.numericFilters ? tab.numericFilters : []}
                  />
                </div>
              )}
            </div>
          );
        })
      }
    </div>
  );
};

export default AdminDashboardTableTabs;
